import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import valuationsDetailsReducer from "./valuations.slice"
import promptDetailsReducer from "./prompts.slice"
import navigationDetailsReducer from "./navigation.slice"
import notificationsDetailsReducer from "./notification.slice"

const persistConfig = {
  nav: {
    key: "navigationDetails",
    version: 1,
    storage,
  },
  valuations: {
    key: "valuationsDetails",
    version: 1,
    storage,
  },
  notifications: {
    key: "notificationsDetails",
    version: 1,
    storage,
  },
}

const store = configureStore({
  reducer: combineReducers({
    valuationsDetails: persistReducer(
      persistConfig.valuations,
      valuationsDetailsReducer
    ),
    promptDetails: promptDetailsReducer,
    notificationsDetails: persistReducer(
      persistConfig.notifications,
      notificationsDetailsReducer
    ),
    navigationDetails: persistReducer(
      persistConfig.nav,
      navigationDetailsReducer
    ),
  }),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

const persistor = persistStore(store)

export { store, persistor }
